import { type FC, type PropsWithChildren, useContext } from "react";

import { UserContext } from "@/app/providers";

import { checkAdminAccess } from "@/service/ApplicationQueries";

export const AdminProtected: FC<PropsWithChildren<unknown>> = (props) => {
	const user = useContext(UserContext);

	return <>{user && checkAdminAccess(user) ? props.children : null}</>;
};
